import React from "react";
import { AnimatedBottomRowItemStyles } from "./HubletViewStyles/HubletViewStyles";
import {
  useBottomLeftItem,
  useBottomMiddleItem,
  useBottomRightItem,
  useIsMiniMode,
} from "./hubletViewUtils";
import { SERVER_NAMES } from "components/Nav/Drawers/RightDrawer/FlightDebugger/SERVER_NAMES";
import { useSettings } from "contexts/SettingsManager/SettingsManager";
import { useShouldUseDataDumpForHubletView } from "utils/customHooks/whichServerHooks";
import { useSpring } from "@react-spring/web";
import { useWindowSize } from "react-use";
export const HubletViewBottomRowItems = React.memo<{
  isGridLayout: boolean;
  minOfWidthOrHeight: number;
  width: number;
}>(props => {
  return (
    <div
      className="bottom-row"
      data-component-name={"Hublet View Bottom Row Items"}
    >
      <BottomLeftItem {...props} />
      <BottomMiddleItem {...props} />
      <BottomRightItem {...props} />
    </div>
  );
});
function BottomLeftItem(props: {
  isGridLayout: boolean;
  minOfWidthOrHeight: number;
  width: number;
}) {
  const item = useBottomLeftItem();
  return <BottomRowItem {...props} {...item} />;
}
function BottomMiddleItem(props: {
  isGridLayout: boolean;
  minOfWidthOrHeight: number;
  width: number;
}) {
  const item = useBottomMiddleItem();
  return <BottomRowItem {...props} {...item} />;
}
function BottomRightItem(props: {
  isGridLayout: boolean;
  minOfWidthOrHeight: number;
  width: number;
}) {
  const item = useBottomRightItem();
  return <BottomRowItem {...props} {...item} />;
}
function BottomRowItem({
  id,
  top,
  middle,
  bottom,
  isGridLayout,
  minOfWidthOrHeight,
  width,
}: {
  id: number;
  top: string | React.JSX.Element;
  middle: string | React.JSX.Element;
  bottom?: string | React.JSX.Element;
  isGridLayout: boolean;
  minOfWidthOrHeight: number;
  width: number;
}) {
  const shouldUseDataDumps = useShouldUseDataDumpForHubletView();
  const { isUsingRateRollingTimeWindow } = useSettings();
  const [isMiniMode] = useIsMiniMode();
  const windowSize = useWindowSize();
  // 🐱‍💻
  const translateY =
    windowSize.width > 3000
      ? -40
      : windowSize.width > 2500
        ? -50
        : windowSize.width > 2000
          ? 20
          : windowSize.width > 1920
            ? -50
            : windowSize.width > 1800
              ? -170
              : windowSize.width > 1200
                ? -150
                : -260;
  const springScale = useSpring({
    transform: `scale(${isMiniMode ? 0.2 : 1}) translateY(${
      isMiniMode ? translateY : 0
    }%)`,
  });
  return (
    <AnimatedBottomRowItemStyles
      style={springScale}
      $width={isGridLayout ? minOfWidthOrHeight : width}
      key={id}
      $isGridLayout={isGridLayout}
      $isMiniMode={isMiniMode}
      className="bottom-row-item"
      data-component-name={`Hublet View Bottom Row Item ${id}`}
    >
      <div className="row-1">{top}</div>
      <div
        className="row-2"
        {...(id !== 1
          ? {
              "data-server-names": [
                isUsingRateRollingTimeWindow
                  ? SERVER_NAMES.midgardDataDumpRollingWindow
                  : SERVER_NAMES.midgardDataDumpHubletView,
              ],
            }
          : {})}
        {...(id === 1
          ? {
              "data-server-names": [
                shouldUseDataDumps
                  ? SERVER_NAMES.midgardDataDumpHubletView
                  : SERVER_NAMES.askrAggregates,
              ],
            }
          : {})}
      >
        {middle}
      </div>
      <div className="row-3">{bottom}</div>
    </AnimatedBottomRowItemStyles>
  );
}
